// import slug from 'slugify';
import removeDiacritics from 'utils/removeDiacritics';

export default class Movie {

	constructor(id, attr, format) {
		this.id = id;
		this.title = attr.title;

		// this.slug = slug(attr.title, { lower: true, remove: /[^\w\s\-\.\_~]/g });
		// this.slug = attr.title.toLowerCase().replace(/\s+/g, '-').replace(/[^-_a-z0-9]/g, '');
		this.slug = attr.slugOverride || removeDiacritics(attr.title.toLowerCase()).replace(/[^\w\s_-]/g, '').replace(/[\s_-]+/g, '-');
		this.format = format;

		// add other theater attributes here
		this.movietickets = attr.movietickets_movie_id;
		this.atom = attr.atom;

		this.provider_movie_id = attr.provider_movie_id;
		this.provider_id = attr.provider_id;

		// Require for filter grouping
		this.group = attr.group;

		// this.meta = attr.meta;

		this.fandango = (attr.meta && attr.meta.movie_code_id) || attr.fandango_movie_id;
	}

}
